<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
  allowLoggedInOnly: true
</route>

<script setup>
import RestaurantMessagingPage from '@core/components/RestaurantMessagingPage.vue'
</script>

<template>
  <div
    class="ra-messages-page"
    style="height: calc(100vh - 64px);"
  >
    <RestaurantMessagingPage />
  </div>
</template>
